import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import DICT from "./dict";

const debug = true;

const map = {
  _default:                        { region: "EU", lang: "en_UK", country: false },

  "www.sunrisemedical.lat":        { region: "US", lang: "es",    country: false },            // Spanish
  "www.sunrisemedical.com.au":     { region: "US", lang: "en_UK", country: "AUSTRALIA" },      // English
  "www.sunrisemedical.be":         { region: "EU", lang: "de",    country: "BELGIUM" },        // German
  "fr.sunrisemedical.be":          { region: "EU", lang: "fr",    country: "BELGIUM" },        // French
  "www.sunrisemedical.ca":         { region: "US", lang: "en",    country: "CANADA" },
  "www.medicco.cz":                { region: "EU", lang: "cs",    country: "CZECH_REPUBLIC" }, // Czech
  "www.sunrisemedical.dk":         { region: "EU", lang: "da",    country: "DENMARK" },        // Danish
  "www.sunrisemedical.de":         { region: "EU", lang: "de",    country: "GERMANY" },
  "www.sunrisemedical.es":         { region: "EU", lang: "es",    country: "SPAIN" },
  "www.sunrisemedical.fr":         { region: "EU", lang: "fr",    country: "FRANCE" },
  "www.sunrisemedical.eu":         { region: "EU", lang: "en",    country: false },
  "www.sunrisemedical.it":         { region: "EU", lang: "it",    country: "ITALY" },          // Italian
  "www.sunrisemedical.nl":         { region: "EU", lang: "nl",    country: "NETHERLANDS" },    // Dutch
  "www.sunrisemedical.no":         { region: "EU", lang: "no",    country: "NORWAY" },         // Norwegian
  "www.sunrisemedical.at":         { region: "EU", lang: "de",    country: "AUSTRIA" },
  "www.sunrise-medical.pl":        { region: "EU", lang: "pl",    country: "POLAND" },         // Polish
  "www.sunrisemedical.pt":         { region: "EU", lang: "pt",    country: "PORTUGAL" },       // Portuguese
  "www.sunrisemedical.ch":         { region: "EU", lang: "de",    country: "SWITZERLAND" },
  "www.sunrisemedical.se":         { region: "EU", lang: "sv",    country: "SWEDEN" },         // Swedish
  "www.sunrisemedical.co.uk":      { region: "EU", lang: "en_UK", country: "UK" },
  "www.sunrisemedical.com":        { region: "US", lang: "en_US", country: "US" }
};

function getLocaleInfoFromUrl() {
  // const url = new URL("https://" + "www.sunrisemedical.fr" + "/something");

  const url = new URL(window.location.toString());
  const hostname = url.hostname;
  const match = map[hostname] || false;

  let language = map._default.lang;
  let region = map._default.region;
  let country = map._default.country;

  if (match) {
    language = match.lang;
    region = match.region;
    country = map.country;
  } else {
    debug && console.log("I18N defaults");
  }

  if (url.searchParams.has("lang")) {
    const langParam = url.searchParams.get("lang");
    language = langParam;
  }

  if (url.searchParams.has("region")) {
    const regionParam = url.searchParams.get("region").toUpperCase();
    if (/(US|EU)/.test(regionParam)) {
      region = regionParam;
    }
  }

  if (url.searchParams.has("country")) {
    const countryParam = url.searchParams.get("country").toUpperCase();
    country = countryParam;
  }

  debug && console.log("I18N", language, country, region);

  return { url: url.origin, language, region, country };
}

const locale = getLocaleInfoFromUrl();

export const SM_URL = locale.url;
export const SM_LANG = locale.language;
export const SM_REGION = locale.region;
export const SM_COUNTRY = locale.country;

const defaultLng = locale.language;
const resources = DICT;

i18n.use(initReactI18next).init({
  interpolation: { escapeValue: false },
  defaultNS: "common",
  fallbackLng: defaultLng,
  lng: defaultLng,
  resources,
});

export default i18n;
